(function () {
  "use strict";

  // ── Config ──────────────────────────────────────────────────────────────
  var cfg = window.__SK_SS_CONFIG || {};
  var API = cfg.apiUrl || "https://erp-api-289183413262.europe-west1.run.app";
  var STORAGE_KEY = "sk_ss_session";
  var TTL = 2 * 60 * 60 * 1000;

  // ── State ───────────────────────────────────────────────────────────────
  var S = {
    view: "login",
    sid: null,
    token: null,
    order: null,
    tracking: null,
    products: [],
    messages: [],
    chatLoading: false,
    loading: false,
    error: null,
    overlay: null, // null | "claim" | "return" | "cancel"
    claimStep: 0,
    claimData: { items: [], damageType: "", description: "", photoKeys: [] },
    returnData: { items: [], reason: "", comment: "" },
    cancelData: { reason: "", comment: "" },
    expandedFaqs: {},
  };

  var root;

  // ── API Helper ────────────────────────────────────────────────────────
  function api(path, opts) {
    var headers = { "Content-Type": "application/json" };
    if (S.token) headers["Authorization"] = "Bearer " + S.token;
    return fetch(API + "/self-service" + path, Object.assign({ headers: headers }, opts))
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error((d.error && d.error.message) || "Fehler " + r.status); });
        return r.json();
      })
      .then(function (d) { return d.data; });
  }

  // ── Session Persistence ───────────────────────────────────────────────
  function saveSession() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        sid: S.sid, token: S.token, order: S.order, tracking: S.tracking,
        products: S.products, ts: Date.now()
      }));
    } catch (e) { /* ok */ }
  }

  function loadSession() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var d = JSON.parse(raw);
      if (Date.now() - d.ts > TTL) { localStorage.removeItem(STORAGE_KEY); return false; }
      S.sid = d.sid; S.token = d.token; S.order = d.order;
      S.tracking = d.tracking; S.products = d.products || [];
      return true;
    } catch (e) { return false; }
  }

  function clearSession() {
    S.sid = null; S.token = null; S.order = null; S.tracking = null;
    S.products = []; S.messages = [];
    localStorage.removeItem(STORAGE_KEY);
  }

  // ── Styles ────────────────────────────────────────────────────────────
  // Styles now live in assets/sk-self-service.css and are loaded via <link>
  // from sections/self-service-portal.liquid. This function is kept as a
  // no-op guard in case the stylesheet somehow failed to load, and also
  // prevents duplicate style injection if init() runs twice.
  function injectStyles() {
    if (document.documentElement.classList.contains("sk-ss-styles-ready")) return;
    document.documentElement.classList.add("sk-ss-styles-ready");
  }

  // ── Helpers ────────────────────────────────────────────────────────────

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }

  function formatDate(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  function formatMoney(val, cur) {
    if (!val) return "–";
    var n = parseFloat(val);
    return isNaN(n) ? val : n.toFixed(2).replace(".", ",") + " " + (cur || "€");
  }

  // Parse [text](url) links in AI messages
  function parseLinks(text) {
    return text
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
      .replace(/\n/g, "<br>");
  }

  function scrollChatBottom() {
    var msgs = root.querySelector(".sk-ss__chat-messages");
    if (msgs) setTimeout(function () { msgs.scrollTop = msgs.scrollHeight; }, 50);
  }

  // ── Login View ────────────────────────────────────────────────────────

  function renderLogin() {
    var wrap = el("div", "sk-ss__login-wrap");
    wrap.innerHTML =
      '<h1 class="sk-ss__login-title">Silberkraft Self-Service</h1>' +
      '<p class="sk-ss__login-sub">Gib deine Bestellnummer und E-Mail-Adresse ein, um auf dein Bestell-Dashboard zuzugreifen.</p>';

    // Show customer orders if logged in
    if (cfg.customer && cfg.customer.orders && cfg.customer.orders.length > 0) {
      var listDiv = el("div", "sk-ss__orders-list");
      listDiv.innerHTML = '<h3 style="margin-bottom:8px">Deine letzten Bestellungen</h3>';
      cfg.customer.orders.forEach(function (o) {
        var row = el("div", "sk-ss__order-row");
        row.innerHTML =
          '<div class="sk-ss__order-row-left"><strong>#' + o.number + '</strong> · ' + o.date + '</div>' +
          '<div class="sk-ss__order-row-right">' + o.total + ' · ' + o.fulfillment + '</div>';
        row.onclick = function () { doLogin(String(o.number), cfg.customer.email); };
        listDiv.appendChild(row);
      });
      wrap.appendChild(listDiv);
      wrap.appendChild(el("p", null, '<span style="display:block;text-align:center;color:#423f3d;font-size:13px;margin-bottom:12px">oder andere Bestellung eingeben:</span>'));
    }

    var form = el("form");
    form.innerHTML =
      '<input class="sk-ss__input" name="orderNumber" placeholder="Bestellnummer (z.B. 88362)" autocomplete="off" inputmode="numeric">' +
      '<input class="sk-ss__input" name="email" type="email" placeholder="E-Mail-Adresse" value="' + (cfg.customer ? cfg.customer.email : "") + '" autocomplete="email">' +
      (S.error ? '<div class="sk-ss__error">' + S.error + '</div>' : '') +
      '<button class="sk-ss__btn sk-ss__btn--full" type="submit"' + (S.loading ? " disabled" : "") + '>' +
      (S.loading ? 'Wird geladen...' : 'Bestellung aufrufen') + '</button>';

    form.onsubmit = function (e) {
      e.preventDefault();
      var orderNum = form.elements.orderNumber.value.trim();
      var email = form.elements.email.value.trim();
      if (!orderNum || !email) { S.error = "Bitte fülle beide Felder aus."; render(); return; }
      doLogin(orderNum, email);
    };
    wrap.appendChild(form);
    return wrap;
  }

  function doLogin(orderNum, email) {
    S.loading = true; S.error = null; render();
    api("/sessions", {
      method: "POST",
      body: JSON.stringify({ orderNumber: orderNum, email: email })
    }).then(function (d) {
      S.sid = d.sessionId;
      S.token = d.sessionToken;
      S.order = d.order;
      S.tracking = d.tracking;
      S.products = d.products || [];
      S.view = "dashboard";
      S.loading = false;
      S.messages = [];
      saveSession();
      render();
      // Auto-load chat history then send init message
      loadMessages().then(function () {
        if (S.messages.length === 0) sendChat("Hallo! Ich habe eine Frage zu meiner Bestellung.");
      });
    }).catch(function (err) {
      S.loading = false; S.error = err.message; render();
    });
  }

  // ── Chat Functions ────────────────────────────────────────────────────

  function loadMessages() {
    return api("/sessions/" + S.sid + "/messages").then(function (msgs) {
      S.messages = (msgs || []).map(function (m) {
        return { role: m.role, body: m.body };
      });
      renderChatMessages();
    }).catch(function () { /* ok */ });
  }

  function sendChat(text) {
    if (!text || S.chatLoading) return;
    S.messages.push({ role: "user", body: text });
    S.chatLoading = true;
    renderChatMessages();
    scrollChatBottom();

    api("/sessions/" + S.sid + "/chat", {
      method: "POST",
      body: JSON.stringify({ body: text })
    }).then(function (d) {
      S.messages.push({ role: "assistant", body: d.body });
      S.chatLoading = false;
      renderChatMessages();
      scrollChatBottom();
    }).catch(function (err) {
      S.messages.push({ role: "assistant", body: "Entschuldigung, da ist etwas schiefgelaufen. Bitte versuche es nochmal." });
      S.chatLoading = false;
      renderChatMessages();
      scrollChatBottom();
    });
  }

  function renderChatMessages() {
    var container = root.querySelector(".sk-ss__chat-messages");
    if (!container) return;
    var html = "";
    S.messages.forEach(function (m) {
      if (m.role === "system") return;
      var cls = m.role === "user" ? "sk-ss__msg sk-ss__msg--user" : "sk-ss__msg sk-ss__msg--assistant";
      html += '<div class="' + cls + '"><div class="sk-ss__msg-bubble">' + parseLinks(m.body) + '</div></div>';
    });
    if (S.chatLoading) {
      html += '<div class="sk-ss__msg sk-ss__msg--assistant"><div class="sk-ss__typing"><div class="sk-ss__typing-dot"></div><div class="sk-ss__typing-dot"></div><div class="sk-ss__typing-dot"></div></div></div>';
    }
    container.innerHTML = html;
  }

  // ── Dashboard View ────────────────────────────────────────────────────

  function renderDashboard() {
    var wrap = el("div");
    var o = S.order;

    // Order card
    var card = el("div", "sk-ss__card sk-ss__card--accent");
    var fulfillBadge = "sk-ss__badge--gray";
    if (o.fulfillmentStatus === "Versendet") fulfillBadge = "sk-ss__badge--green";
    else if (o.fulfillmentStatus === "In Bearbeitung") fulfillBadge = "sk-ss__badge--gold";

    card.innerHTML =
      '<div class="sk-ss__order-header">' +
        '<span class="sk-ss__order-num">Bestellung #' + o.orderNumber + '</span>' +
        '<span class="sk-ss__order-date">' + formatDate(o.orderDate) + '</span>' +
      '</div>' +
      '<div class="sk-ss__order-meta">' +
        '<span class="sk-ss__badge ' + fulfillBadge + '">' + o.fulfillmentStatus + '</span>' +
        '<span class="sk-ss__badge sk-ss__badge--gray">' + formatMoney(o.total, o.currency) + '</span>' +
        '<span class="sk-ss__badge sk-ss__badge--gray">' + o.items.length + ' Artikel</span>' +
      '</div>';

    // Items
    var itemsHtml = '<ul class="sk-ss__items">';
    o.items.forEach(function (i) {
      itemsHtml += '<li class="sk-ss__item"><div><div class="sk-ss__item-name">' +
        i.quantity + 'x ' + (i.title || i.sku || "Artikel") +
        '</div></div><div class="sk-ss__item-price">' +
        formatMoney(i.totalPrice, o.currency) + '</div></li>';
    });
    itemsHtml += '</ul>';
    card.innerHTML += itemsHtml;
    wrap.appendChild(card);

    // Tracking card
    if (S.tracking) {
      wrap.appendChild(renderTrackingCard());
    }

    // Products with FAQs
    if (S.products && S.products.length > 0) {
      var prodCard = el("div", "sk-ss__card");
      prodCard.innerHTML = '<h3>Produktinfos & FAQs</h3>';
      S.products.forEach(function (p, pi) {
        var pEl = el("div", "sk-ss__product");
        var benefitsHtml = p.benefits && p.benefits.length > 0
          ? '<div class="sk-ss__product-benefits">' + p.benefits.slice(0, 3).join(" · ") + '</div>'
          : '';
        var linkHtml = p.shopUrl
          ? '<div class="sk-ss__product-link"><a href="' + p.shopUrl + '" target="_blank" rel="noopener">Im Shop ansehen</a></div>'
          : '';
        pEl.innerHTML =
          '<div class="sk-ss__product-name">' + p.name + '</div>' +
          benefitsHtml + linkHtml;

        // FAQs
        if (p.faqs && p.faqs.length > 0) {
          var faqsDiv = el("div", "sk-ss__product-faqs");
          p.faqs.forEach(function (faq, fi) {
            var key = pi + "_" + fi;
            var faqEl = el("div", "sk-ss__faq");
            var isOpen = S.expandedFaqs[key];
            faqEl.innerHTML =
              '<div class="sk-ss__faq-q"><span>' + faq.question + '</span><span class="sk-ss__faq-arrow' + (isOpen ? " sk-ss__faq-arrow--open" : "") + '">▼</span></div>' +
              '<div class="sk-ss__faq-a' + (isOpen ? " sk-ss__faq-a--open" : "") + '">' + faq.answer + '</div>';
            faqEl.querySelector(".sk-ss__faq-q").onclick = function () {
              S.expandedFaqs[key] = !S.expandedFaqs[key];
              render();
            };
            faqsDiv.appendChild(faqEl);
          });
          pEl.appendChild(faqsDiv);
        }
        prodCard.appendChild(pEl);
      });
      wrap.appendChild(prodCard);
    }

    // Action buttons
    var actions = el("div", "sk-ss__actions");
    var actionItems = [];

    if (o.fulfillmentStatus === "Versendet" && S.tracking) {
      actionItems.push({ icon: "📦", label: "Tracking aktualisieren", action: refreshTracking });
    }
    actionItems.push({ icon: "📸", label: "Schaden melden", action: function () { openOverlay("claim"); } });
    actionItems.push({ icon: "🔄", label: "Retoure einleiten", action: function () { openOverlay("return"); } });
    if (o.fulfillmentStatus !== "Versendet" && o.fulfillmentStatus !== "Zugestellt") {
      actionItems.push({ icon: "❌", label: "Stornierung", action: function () { openOverlay("cancel"); } });
    }
    if (o.invoiceCount > 0) {
      actionItems.push({ icon: "🧾", label: "Rechnung laden", action: loadInvoices });
    }
    if (o.refundCount > 0) {
      actionItems.push({ icon: "💰", label: "Rückerstattung", action: loadRefundStatus });
    }

    actionItems.forEach(function (a) {
      var btn = el("div", "sk-ss__action");
      btn.innerHTML = '<span class="sk-ss__action-icon">' + a.icon + '</span><span class="sk-ss__action-label">' + a.label + '</span>';
      btn.onclick = a.action;
      actions.appendChild(btn);
    });
    wrap.appendChild(actions);

    // Chat section
    wrap.appendChild(renderChat());

    // Logout
    var logout = el("span", "sk-ss__logout", "Andere Bestellung aufrufen");
    logout.onclick = function () { clearSession(); S.view = "login"; render(); };
    wrap.appendChild(logout);

    return wrap;
  }

  // ── Tracking Card ─────────────────────────────────────────────────────

  function renderTrackingCard() {
    var t = S.tracking;
    var card = el("div", t.stuckDays && t.stuckDays >= 3 ? "sk-ss__card sk-ss__card--warning" : "sk-ss__card");

    if (t.stuckDays && t.stuckDays >= 3) {
      card.innerHTML =
        '<h3>Sendungsverfolgung</h3>' +
        '<div class="sk-ss__warning">Dein Paket ist seit ' + t.stuckDays + ' Tagen nur als "elektronisch angekündigt" hinterlegt. Wir haben den Fall automatisch mit Priorität an unser Team weitergeleitet. Du bekommst schnellstmöglich eine Rückmeldung per E-Mail!</div>';
    } else {
      card.innerHTML = '<h3>Sendungsverfolgung</h3>';

      // Progress bar
      var steps = ["Versendet", "Unterwegs", "In Zustellung", "Zugestellt"];
      var status = t.status || "";
      var activeIdx = 0;
      if (status === "in_transit" || status === "transit") activeIdx = 1;
      else if (status === "out_for_delivery") activeIdx = 2;
      else if (status === "delivered") activeIdx = 3;

      var progressHtml = '<div class="sk-ss__progress">';
      steps.forEach(function (label, i) {
        var dotCls = "sk-ss__progress-dot";
        if (i < activeIdx) dotCls += " sk-ss__progress-dot--done";
        else if (i === activeIdx) dotCls += " sk-ss__progress-dot--active";
        var lineCls = "sk-ss__progress-line";
        if (i < activeIdx) lineCls += " sk-ss__progress-line--done";
        progressHtml += '<div class="sk-ss__progress-step">' +
          (i < steps.length - 1 ? '<div class="' + lineCls + '"></div>' : '') +
          '<div class="' + dotCls + '"></div>' +
          '<span>' + label + '</span></div>';
      });
      progressHtml += '</div>';
      card.innerHTML += progressHtml;

      if (t.estimatedDelivery) {
        card.innerHTML += '<p style="font-size:13px;color:#423f3d;margin:0 0 8px">Voraussichtliche Zustellung: <strong>' + t.estimatedDelivery + '</strong></p>';
      }
    }

    // Events timeline
    if (t.events && t.events.length > 0) {
      var timelineHtml = '<div class="sk-ss__timeline">';
      t.events.slice(0, 8).forEach(function (ev) {
        var time = "";
        try {
          var d = new Date(ev.timestamp);
          time = d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) + " " +
                 d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
        } catch (e) { time = ev.timestamp; }
        timelineHtml += '<div class="sk-ss__timeline-item">' +
          '<div class="sk-ss__timeline-desc">' + ev.description + (ev.location ? ' (' + ev.location + ')' : '') + '</div>' +
          '<div class="sk-ss__timeline-time">' + time + '</div></div>';
      });
      timelineHtml += '</div>';
      card.innerHTML += timelineHtml;
    }

    // Tracking number + link
    if (t.trackingNumber) {
      var linkHtml = t.trackingUrl
        ? '<a href="' + t.trackingUrl + '" target="_blank" rel="noopener">' + t.trackingNumber + '</a>'
        : t.trackingNumber;
      card.innerHTML += '<p style="font-size:12px;color:#423f3d;margin:8px 0 0">Sendungsnummer: ' + linkHtml + '</p>';
    }

    return card;
  }

  function refreshTracking() {
    api("/sessions/" + S.sid + "/tracking").then(function (d) {
      if (d.tracking) {
        S.tracking = Object.assign({}, S.tracking, d.tracking, {
          trackingUrl: d.trackingUrl || S.tracking.trackingUrl
        });
      }
      saveSession();
      render();
    }).catch(function (err) {
      alert(err.message);
    });
  }

  // ── Chat Widget ───────────────────────────────────────────────────────

  function renderChat() {
    var chat = el("div", "sk-ss__chat");
    chat.innerHTML =
      '<div class="sk-ss__chat-header">💬 Dein persönlicher Assistent</div>' +
      '<div class="sk-ss__chat-messages"></div>';

    // Quick action chips
    var chips = el("div", "sk-ss__chips");
    var chipTexts = [];
    if (S.tracking) chipTexts.push("Wo ist mein Paket?");
    chipTexts.push("Produkt-Frage");
    chipTexts.push("Retoure einleiten");
    chipTexts.push("Rechnung anfordern");

    chipTexts.forEach(function (text) {
      var chip = el("span", "sk-ss__chip", text);
      chip.onclick = function () { sendChat(text); };
      chips.appendChild(chip);
    });
    chat.appendChild(chips);

    // Input
    var inputWrap = el("div", "sk-ss__chat-input");
    inputWrap.innerHTML =
      '<input type="text" placeholder="Schreib mir eine Nachricht..." maxlength="2000">' +
      '<button class="sk-ss__chat-send" title="Senden"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg></button>';

    var input = inputWrap.querySelector("input");
    var sendBtn = inputWrap.querySelector("button");

    function doSend() {
      var text = input.value.trim();
      if (!text) return;
      input.value = "";
      sendChat(text);
    }

    sendBtn.onclick = doSend;
    input.onkeydown = function (e) {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); doSend(); }
    };

    chat.appendChild(inputWrap);
    return chat;
  }

  // ── Overlay Panels ────────────────────────────────────────────────────

  function openOverlay(type) {
    S.overlay = type;
    if (type === "claim") { S.claimStep = 0; S.claimData = { items: [], damageType: "", description: "", photoKeys: [] }; }
    if (type === "return") { S.returnData = { items: [], reason: "", comment: "" }; }
    if (type === "cancel") { S.cancelData = { reason: "", comment: "" }; }
    renderOverlay();
  }

  function closeOverlay() {
    S.overlay = null;
    var ovEl = root.querySelector(".sk-ss__overlay");
    if (ovEl) ovEl.remove();
  }

  function renderOverlay() {
    // Remove existing
    var existing = root.querySelector(".sk-ss__overlay");
    if (existing) existing.remove();
    if (!S.overlay) return;

    var overlay = el("div", "sk-ss__overlay");
    var panel = el("div", "sk-ss__panel");

    if (S.overlay === "claim") panel.appendChild(renderClaimPanel());
    else if (S.overlay === "return") panel.appendChild(renderReturnPanel());
    else if (S.overlay === "cancel") panel.appendChild(renderCancelPanel());

    overlay.appendChild(panel);
    overlay.onclick = function (e) { if (e.target === overlay) closeOverlay(); };
    root.appendChild(overlay);
  }

  // ── Claim Panel ───────────────────────────────────────────────────────

  function renderClaimPanel() {
    var wrap = el("div");
    wrap.innerHTML =
      '<div class="sk-ss__panel-header"><h2>Schaden melden</h2><button class="sk-ss__panel-close" onclick="return false">&times;</button></div>';
    wrap.querySelector(".sk-ss__panel-close").onclick = closeOverlay;

    if (S.claimStep === 0) {
      // Select items
      wrap.innerHTML += '<p>Welche Artikel sind betroffen?</p>';
      var items = S.order.items;
      items.forEach(function (item) {
        var isSelected = S.claimData.items.some(function (i) { return i.lineItemId === item.id; });
        var itemEl = el("div", "sk-ss__check-item" + (isSelected ? " sk-ss__check-item--selected" : ""));
        itemEl.innerHTML =
          '<div class="sk-ss__check-box">' + (isSelected ? "✓" : "") + '</div>' +
          '<div><div class="sk-ss__item-name">' + item.quantity + 'x ' + (item.title || item.sku) + '</div></div>';
        itemEl.onclick = function () {
          if (isSelected) {
            S.claimData.items = S.claimData.items.filter(function (i) { return i.lineItemId !== item.id; });
          } else {
            S.claimData.items.push({ lineItemId: item.id, quantity: item.quantity });
          }
          renderOverlay();
        };
        wrap.appendChild(itemEl);
      });

      var nextBtn = el("button", "sk-ss__btn sk-ss__btn--full", "Weiter");
      nextBtn.disabled = S.claimData.items.length === 0;
      nextBtn.onclick = function () { if (S.claimData.items.length > 0) { S.claimStep = 1; renderOverlay(); } };
      wrap.appendChild(el("div", null, "<br>"));
      wrap.appendChild(nextBtn);

    } else if (S.claimStep === 1) {
      // Describe damage
      wrap.innerHTML += '<p>Was ist passiert?</p>';
      var select = el("select", "sk-ss__input");
      select.innerHTML =
        '<option value="">Bitte wählen...</option>' +
        '<option value="product_damaged"' + (S.claimData.damageType === "product_damaged" ? " selected" : "") + '>Produkt beschädigt/undicht</option>' +
        '<option value="packaging_damaged"' + (S.claimData.damageType === "packaging_damaged" ? " selected" : "") + '>Verpackung beschädigt</option>' +
        '<option value="wrong_product"' + (S.claimData.damageType === "wrong_product" ? " selected" : "") + '>Falsches Produkt erhalten</option>' +
        '<option value="product_missing"' + (S.claimData.damageType === "product_missing" ? " selected" : "") + '>Produkt fehlt in der Lieferung</option>';
      select.onchange = function () { S.claimData.damageType = select.value; };
      wrap.appendChild(select);

      wrap.appendChild(el("p", null, "Beschreibung (optional):"));
      var ta = el("textarea", "sk-ss__input");
      ta.placeholder = "Beschreibe den Schaden kurz...";
      ta.maxLength = 1000;
      ta.value = S.claimData.description;
      ta.oninput = function () { S.claimData.description = ta.value; };
      wrap.appendChild(ta);

      var btnRow = el("div", null, "");
      btnRow.style.cssText = "display:flex;gap:8px;margin-top:8px";
      var backBtn = el("button", "sk-ss__btn sk-ss__btn--outline", "Zurück");
      backBtn.onclick = function () { S.claimStep = 0; renderOverlay(); };
      var nextBtn2 = el("button", "sk-ss__btn", "Weiter");
      nextBtn2.disabled = !S.claimData.damageType;
      nextBtn2.onclick = function () {
        if (S.claimData.damageType) {
          // Skip photo step if not damage type needing photos
          if (S.claimData.damageType === "wrong_product" || S.claimData.damageType === "product_missing") {
            S.claimStep = 3; // straight to confirm
          } else {
            S.claimStep = 2;
          }
          renderOverlay();
        }
      };
      nextBtn2.style.flex = "1";
      btnRow.appendChild(backBtn);
      btnRow.appendChild(nextBtn2);
      wrap.appendChild(btnRow);

    } else if (S.claimStep === 2) {
      // Photo upload
      wrap.innerHTML += '<p>Bitte lade mindestens ein Foto des Schadens hoch (max. 5).</p>';
      // Simple file input
      var photosDiv = el("div", "sk-ss__photos");
      var addBtn = el("label", "sk-ss__photo-add", "+");
      var fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/jpeg,image/png,image/webp";
      fileInput.capture = "environment";
      fileInput.style.display = "none";
      fileInput.onchange = function () {
        if (fileInput.files && fileInput.files[0]) {
          uploadPhoto(fileInput.files[0]);
          fileInput.value = "";
        }
      };
      addBtn.appendChild(fileInput);
      if (S.claimData.photoKeys.length < 5) photosDiv.appendChild(addBtn);
      wrap.appendChild(photosDiv);

      if (S.claimData.photoKeys.length > 0) {
        wrap.appendChild(el("p", null, '<span style="color:#01a071;font-size:13px">' + S.claimData.photoKeys.length + ' Foto(s) hochgeladen</span>'));
      }

      var btnRow2 = el("div");
      btnRow2.style.cssText = "display:flex;gap:8px;margin-top:12px";
      var backBtn2 = el("button", "sk-ss__btn sk-ss__btn--outline", "Zurück");
      backBtn2.onclick = function () { S.claimStep = 1; renderOverlay(); };
      var nextBtn3 = el("button", "sk-ss__btn", "Weiter");
      nextBtn3.disabled = S.claimData.photoKeys.length === 0;
      nextBtn3.onclick = function () { if (S.claimData.photoKeys.length > 0) { S.claimStep = 3; renderOverlay(); } };
      nextBtn3.style.flex = "1";
      btnRow2.appendChild(backBtn2);
      btnRow2.appendChild(nextBtn3);
      wrap.appendChild(btnRow2);

    } else if (S.claimStep === 3) {
      // Confirm + submit
      var labels = { product_damaged: "Produkt beschädigt/undicht", packaging_damaged: "Verpackung beschädigt", wrong_product: "Falsches Produkt", product_missing: "Produkt fehlt" };
      wrap.innerHTML += '<div class="sk-ss__card" style="margin-bottom:16px"><p><strong>Schadensart:</strong> ' + (labels[S.claimData.damageType] || "") + '</p>' +
        '<p><strong>Betroffene Artikel:</strong> ' + S.claimData.items.length + '</p>' +
        (S.claimData.description ? '<p><strong>Beschreibung:</strong> ' + S.claimData.description.slice(0, 200) + '</p>' : '') +
        '<p><strong>Fotos:</strong> ' + S.claimData.photoKeys.length + '</p></div>';

      var submitBtn = el("button", "sk-ss__btn sk-ss__btn--full sk-ss__btn--gold", "Schadensmeldung absenden");
      submitBtn.onclick = submitClaim;
      wrap.appendChild(submitBtn);

      var backBtn3 = el("button", "sk-ss__btn sk-ss__btn--ghost sk-ss__btn--full", "Zurück");
      backBtn3.onclick = function () { S.claimStep = S.claimData.damageType === "wrong_product" || S.claimData.damageType === "product_missing" ? 1 : 2; renderOverlay(); };
      wrap.appendChild(backBtn3);
    }

    return wrap;
  }

  function uploadPhoto(file) {
    api("/sessions/" + S.sid + "/upload-url", {
      method: "POST",
      body: JSON.stringify({ fileName: file.name, contentType: file.type, fileSizeBytes: file.size })
    }).then(function (d) {
      return fetch(d.uploadUrl, { method: "PUT", headers: { "Content-Type": file.type }, body: file })
        .then(function () { S.claimData.photoKeys.push(d.objectKey); renderOverlay(); });
    }).catch(function (err) { alert("Upload fehlgeschlagen: " + err.message); });
  }

  function submitClaim() {
    api("/sessions/" + S.sid + "/claims", {
      method: "POST",
      body: JSON.stringify(S.claimData)
    }).then(function (d) {
      closeOverlay();
      sendChat("Ich habe gerade eine Schadensmeldung eingereicht. Kannst du mir bestätigen, was die nächsten Schritte sind?");
    }).catch(function (err) { alert(err.message); });
  }

  // ── Return Panel ──────────────────────────────────────────────────────

  function renderReturnPanel() {
    var wrap = el("div");
    wrap.innerHTML =
      '<div class="sk-ss__panel-header"><h2>Retoure einleiten</h2><button class="sk-ss__panel-close">&times;</button></div>' +
      '<p>Welche Artikel möchtest du zurücksenden?</p>';
    wrap.querySelector(".sk-ss__panel-close").onclick = closeOverlay;

    S.order.items.forEach(function (item) {
      var isSelected = S.returnData.items.some(function (i) { return i.lineItemId === item.id; });
      var itemEl = el("div", "sk-ss__check-item" + (isSelected ? " sk-ss__check-item--selected" : ""));
      itemEl.innerHTML =
        '<div class="sk-ss__check-box">' + (isSelected ? "✓" : "") + '</div>' +
        '<div><div class="sk-ss__item-name">' + item.quantity + 'x ' + (item.title || item.sku) + '</div></div>';
      itemEl.onclick = function () {
        if (isSelected) S.returnData.items = S.returnData.items.filter(function (i) { return i.lineItemId !== item.id; });
        else S.returnData.items.push({ lineItemId: item.id, quantity: item.quantity });
        renderOverlay();
      };
      wrap.appendChild(itemEl);
    });

    wrap.appendChild(el("p", null, "<br>Grund:"));
    var select = el("select", "sk-ss__input");
    select.innerHTML =
      '<option value="">Bitte wählen...</option>' +
      '<option value="not_liked"' + (S.returnData.reason === "not_liked" ? " selected" : "") + '>Gefällt nicht</option>' +
      '<option value="wrong_order"' + (S.returnData.reason === "wrong_order" ? " selected" : "") + '>Falsch bestellt</option>' +
      '<option value="too_many"' + (S.returnData.reason === "too_many" ? " selected" : "") + '>Zu viel bestellt</option>' +
      '<option value="other"' + (S.returnData.reason === "other" ? " selected" : "") + '>Sonstiger Grund</option>';
    select.onchange = function () { S.returnData.reason = select.value; };
    wrap.appendChild(select);

    var ta = el("textarea", "sk-ss__input");
    ta.placeholder = "Kommentar (optional)";
    ta.maxLength = 1000;
    ta.value = S.returnData.comment;
    ta.oninput = function () { S.returnData.comment = ta.value; };
    wrap.appendChild(ta);

    var submitBtn = el("button", "sk-ss__btn sk-ss__btn--full", "Retoure beantragen");
    submitBtn.disabled = S.returnData.items.length === 0 || !S.returnData.reason;
    submitBtn.onclick = function () {
      api("/sessions/" + S.sid + "/returns", {
        method: "POST",
        body: JSON.stringify(S.returnData)
      }).then(function (d) {
        closeOverlay();
        sendChat("Ich habe eine Retoure beantragt. Was muss ich als nächstes tun?");
      }).catch(function (err) { alert(err.message); });
    };
    wrap.appendChild(el("div", null, "<br>"));
    wrap.appendChild(submitBtn);

    return wrap;
  }

  // ── Cancel Panel ──────────────────────────────────────────────────────

  function renderCancelPanel() {
    var wrap = el("div");
    wrap.innerHTML =
      '<div class="sk-ss__panel-header"><h2>Stornierung beantragen</h2><button class="sk-ss__panel-close">&times;</button></div>';
    wrap.querySelector(".sk-ss__panel-close").onclick = closeOverlay;

    if (S.order.fulfillmentStatus === "Versendet") {
      wrap.innerHTML += '<div class="sk-ss__warning">Deine Bestellung wurde bereits versendet. Eine Stornierung ist leider nicht mehr möglich. Du kannst stattdessen eine Retoure einleiten.</div>';
      var retBtn = el("button", "sk-ss__btn sk-ss__btn--full", "Retoure einleiten");
      retBtn.onclick = function () { closeOverlay(); openOverlay("return"); };
      wrap.appendChild(retBtn);
      return wrap;
    }

    wrap.appendChild(el("p", null, "Warum möchtest du stornieren?"));
    var select = el("select", "sk-ss__input");
    select.innerHTML =
      '<option value="">Bitte wählen...</option>' +
      '<option value="wrong_order"' + (S.cancelData.reason === "wrong_order" ? " selected" : "") + '>Falsch bestellt</option>' +
      '<option value="not_needed"' + (S.cancelData.reason === "not_needed" ? " selected" : "") + '>Nicht mehr benötigt</option>' +
      '<option value="different_product"' + (S.cancelData.reason === "different_product" ? " selected" : "") + '>Anderes Produkt gewünscht</option>' +
      '<option value="other"' + (S.cancelData.reason === "other" ? " selected" : "") + '>Sonstiger Grund</option>';
    select.onchange = function () { S.cancelData.reason = select.value; };
    wrap.appendChild(select);

    var ta = el("textarea", "sk-ss__input");
    ta.placeholder = "Kommentar (optional)";
    ta.maxLength = 1000;
    ta.value = S.cancelData.comment;
    ta.oninput = function () { S.cancelData.comment = ta.value; };
    wrap.appendChild(ta);

    var submitBtn = el("button", "sk-ss__btn sk-ss__btn--full sk-ss__btn--gold", "Stornierung beantragen");
    submitBtn.disabled = !S.cancelData.reason;
    submitBtn.onclick = function () {
      api("/sessions/" + S.sid + "/cancel", {
        method: "POST",
        body: JSON.stringify(S.cancelData)
      }).then(function (d) {
        closeOverlay();
        sendChat("Ich habe eine Stornierung beantragt. Wie geht es jetzt weiter?");
      }).catch(function (err) {
        if (err.message.indexOf("bereits versendet") > -1) {
          alert("Deine Bestellung wurde bereits versendet. Du kannst stattdessen eine Retoure einleiten.");
        } else {
          alert(err.message);
        }
      });
    };
    wrap.appendChild(el("div", null, "<br>"));
    wrap.appendChild(submitBtn);

    return wrap;
  }

  // ── Invoice / Refund Actions (via chat) ───────────────────────────────

  function loadInvoices() {
    api("/sessions/" + S.sid + "/invoices").then(function (d) {
      if (!d.invoices || d.invoices.length === 0) {
        sendChat("Gibt es eine Rechnung zu meiner Bestellung?");
        return;
      }
      // Show invoices in a temporary info box
      var html = '<div class="sk-ss__card"><h3>Rechnungen</h3>';
      d.invoices.forEach(function (inv) {
        html += '<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid #f0f0f0">' +
          '<div><strong>' + inv.invoiceNumber + '</strong><br><span style="font-size:12px;color:#423f3d">' + formatDate(inv.invoiceDate) + ' · ' + formatMoney(inv.grossAmount) + '</span></div>' +
          (inv.pdfUrl ? '<a href="' + inv.pdfUrl + '" target="_blank" rel="noopener" class="sk-ss__btn sk-ss__btn--small">PDF</a>' : '') +
          '</div>';
      });
      html += '</div>';

      // Insert before chat
      var chatEl = root.querySelector(".sk-ss__chat");
      if (chatEl) {
        var infoEl = el("div");
        infoEl.innerHTML = html;
        chatEl.parentNode.insertBefore(infoEl, chatEl);
        setTimeout(function () { infoEl.remove(); }, 30000); // auto-remove after 30s
      }
    }).catch(function (err) { alert(err.message); });
  }

  function loadRefundStatus() {
    api("/sessions/" + S.sid + "/refund-status").then(function (d) {
      var hasData = (d.creditNotes && d.creditNotes.length > 0) || (d.returns && d.returns.length > 0);
      if (!hasData) {
        sendChat("Gibt es eine Rückerstattung zu meiner Bestellung?");
        return;
      }

      var html = '<div class="sk-ss__card"><h3>Rückerstattungen</h3>';
      if (d.creditNotes) {
        d.creditNotes.forEach(function (cn) {
          var color = cn.status === "erledigt" || cn.status === "gutgeschrieben" ? "#01a071" : "#faa41a";
          html += '<div style="padding:8px 0;border-bottom:1px solid #f0f0f0">' +
            '<strong>' + cn.documentNumber + '</strong> · ' + formatDate(cn.creditDate) + ' · ' + formatMoney(cn.grossAmount) +
            ' <span style="color:' + color + ';font-weight:600">' + (cn.status || "offen") + '</span>' +
            (cn.reason ? '<br><span style="font-size:12px;color:#423f3d">' + cn.reason + '</span>' : '') +
            '</div>';
        });
      }
      if (d.returns) {
        d.returns.forEach(function (r) {
          html += '<div style="padding:8px 0;border-bottom:1px solid #f0f0f0">' +
            '<strong>Retoure ' + r.documentNumber + '</strong> · Status: ' + (r.status || "offen") +
            (r.reason ? '<br><span style="font-size:12px;color:#423f3d">' + r.reason + '</span>' : '') +
            '</div>';
        });
      }
      html += '</div>';

      var chatEl = root.querySelector(".sk-ss__chat");
      if (chatEl) {
        var infoEl = el("div");
        infoEl.innerHTML = html;
        chatEl.parentNode.insertBefore(infoEl, chatEl);
        setTimeout(function () { infoEl.remove(); }, 30000);
      }
    }).catch(function (err) { alert(err.message); });
  }

  // ── Render ────────────────────────────────────────────────────────────

  function render() {
    if (!root) return;
    // Keep overlay separate
    var overlayEl = root.querySelector(".sk-ss__overlay");

    root.innerHTML = "";
    var content;
    if (S.view === "login") content = renderLogin();
    else if (S.view === "dashboard") content = renderDashboard();
    else content = renderLogin();

    root.appendChild(content);

    // Re-render chat messages if on dashboard
    if (S.view === "dashboard") {
      renderChatMessages();
      scrollChatBottom();
    }

    // Restore overlay
    if (overlayEl && S.overlay) {
      root.appendChild(overlayEl);
    }
  }

  // ── Init ──────────────────────────────────────────────────────────────

  function init() {
    var mountPoint = document.getElementById("sk-self-service");
    if (!mountPoint) return;

    injectStyles();
    root = el("div", "sk-ss");
    mountPoint.appendChild(root);

    // Try to restore session
    if (loadSession()) {
      S.view = "dashboard";
      render();
      loadMessages();
    } else {
      render();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
